import useSWR from "swr"

import { getClientProtected } from "../../clients/clients"
import { getAddressMapper } from "../../mappers/singleApplication/getAddressMapper"
import { NO_REVALIDATE_CONFIG } from "../../swrConfig"
import { IAddressSuggestionResults } from "../../types/singleApplication/getAddressTypes"
import { AUTOCOMPLETE_API } from "../../urls/hybrid"

export interface IUseAddress {
    addressId: IAddressSuggestionResults | undefined
    isLoading: boolean
    isError: boolean
}

const useAddress = (
    placeId: string,
    houseNo: string,
    worldwide: boolean
): IUseAddress => {
    /**
     * Makes a request to the `Autocomplete` API and returns the response
     * based on the `placeId` provided
     */
    const {
        data: addressId,
        error,
        isLoading,
    } = useSWR(
        placeId !== "" && placeId !== undefined
            ? AUTOCOMPLETE_API(placeId, houseNo, worldwide)
            : null,
        async (url: string): Promise<IAddressSuggestionResults> => {
            try {
                const res = await getClientProtected(url)
                return getAddressMapper.map(res)
            } catch {
                // TODO - better error handling
                throw Error()
            }
        },
        NO_REVALIDATE_CONFIG
    )

    return {
        addressId,
        isLoading,
        isError: error,
    }
}

export default useAddress
